/* Mindtech — vérification de l'adresse email des jeux : liste d'adresses grand public (contrôle immédiat) et appels au
   service de code à 6 chiffres (Worker Cloudflare « mindtech-verif-email », qui envoie le code depuis la boîte Microsoft 365).
   Chargé avant mt-jeu-*.js ; expose window.MindtechVerif. */
(function () {
  'use strict';
  var FREE = ['gmail.com', 'googlemail.com', 'hotmail.com', 'hotmail.fr', 'hotmail.co.uk', 'outlook.com', 'outlook.fr', 'live.com', 'live.fr', 'msn.com',
    'yahoo.com', 'yahoo.fr', 'ymail.com', 'icloud.com', 'me.com', 'mac.com', 'aol.com', 'free.fr', 'orange.fr', 'wanadoo.fr', 'sfr.fr', 'neuf.fr',
    'laposte.net', 'bbox.fr', 'numericable.fr', 'gmx.com', 'gmx.fr', 'gmx.net', 'protonmail.com', 'proton.me', 'pm.me', 'yopmail.com', 'yopmail.fr',
    'mailinator.com', 'guerrillamail.com', 'temp-mail.org', 'tutanota.com', 'tuta.io', 'zoho.com', 'mail.com', 'email.com', 'hey.com',
    'skynet.be', 'telenet.be', 'bluewin.ch', 'sunrise.ch', 'caramail.com', 'voila.fr', 'club-internet.fr', 'aliceadsl.fr', 'cegetel.net', 'nordnet.fr'];
  var MSG = {
    'free-mail': 'Merci d’utiliser votre adresse professionnelle : les adresses Gmail, Hotmail, Orange… ne sont pas acceptées.',
    'no-mx': 'Ce domaine ne reçoit pas d’email : vérifiez l’adresse.',
    invalid: 'Format d’email invalide',
    'rate-limited': 'Trop de demandes pour cette adresse : réessayez dans une minute.',
    'bad-code': 'Code incorrect ou expiré. Vérifiez le dernier email reçu, ou renvoyez un code.',
    server: 'Le service de vérification est momentanément indisponible. Réessayez dans un instant.',
    network: 'Impossible de joindre le service de vérification. Vérifiez votre connexion et réessayez.',
    origin: 'Service de vérification non autorisé pour ce site.'
  };
  function domain(e) { return String(e || '').toLowerCase().split('@')[1] || ''; }
  function isFreeMail(e) { return FREE.indexOf(domain(e)) >= 0; }
  function message(code) { return MSG[code] || MSG.server; }
  function post(url, path, body) {
    return fetch(String(url).replace(/\/+$/, '') + path, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (r.status >= 500) throw new Error('server'); return r.json(); })
      .then(function (j) { return (j && typeof j.ok === 'boolean') ? j : { ok: false, error: 'server' }; });
  }
  window.MindtechVerif = {
    isFreeMail: isFreeMail,
    message: message,
    send: function (url, email, game) { return post(url, '/send', { email: email, game: game }); },
    check: function (url, email, code) { return post(url, '/check', { email: email, code: code }); }
  };
})();
